export default __webpack_public_path__ + "static/media/2_0088.8040d311.webp";